var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "159.667px",
    height: "159.667px",
    style: {
      fill: "#e7ae3b"
    },
    viewBox: "0 0 159.667 159.667",
    enableBackground: "new 0 0 159.667 159.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.405,105.952V64.244H50.542v41.708h13.865H64.405z M57.478,58.551c4.833,0,7.842-3.203,7.842-7.205 c-0.09-4.094-3.009-7.207-7.75-7.207c-4.745,0-7.844,3.113-7.844,7.207c0,4.002,3.008,7.205,7.661,7.205h0.089L57.478,58.551z  M72.079,105.952H85.94V82.663c0-1.245,0.092-2.493,0.457-3.382c1.003-2.491,3.283-5.071,7.113-5.071 c5.016,0,7.023,3.825,7.023,9.432v22.311h13.861V82.038c0-12.81-6.838-18.771-15.959-18.771c-7.478,0-10.762,4.179-12.586,7.026 h0.092v-6.047H72.081c0.18,3.913-0.002,41.708-0.002,41.708V105.952z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.834,159.667C35.813,159.667,0,123.854,0,79.833C0,35.813,35.813,0,79.834,0c44.02,0,79.833,35.813,79.833,79.833 C159.667,123.854,123.854,159.667,79.834,159.667z M79.834,6C39.122,6,6,39.122,6,79.833c0,40.711,33.122,73.833,73.834,73.833 c40.711,0,73.833-33.122,73.833-73.833C153.667,39.122,120.545,6,79.834,6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.f9215bf1d66086d2c393e720438050e7.svg";
export { ForwardRef as ReactComponent };